import React from 'react';
import './ConfirmationDialog.css';

const ConfirmationDialog = ({ 
  visible = false,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?", 
  confirmText = "Yes",
  cancelText = "No",
  confirmButtonClass = "btn btn--red",
  cancelButtonClass = "btn",
  onConfirm, 
  onCancel 
}) => {
  if (!visible) {
    return null;
  }

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleOverlayClick = (e) => {
    // Close dialog if clicking on overlay (not the modal content)
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  return (
    <div className="confirmation-overlay" onClick={handleOverlayClick}>
      <div className="confirmation-dialog">
        <button
          className="modal-close"
          onClick={handleCancel}
          aria-label="Close dialog"
        >
          &times;
        </button>
        
        <h2 className="confirmation-title">{title}</h2>
        
        <p className="confirmation-message">
          {message}
        </p>
        
        <div className="confirmation-buttons">
          <button 
            className={confirmButtonClass} 
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
          <button 
            className={cancelButtonClass} 
            onClick={handleCancel}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;